import { useEffect } from "react";

// Haptic tap feedback (mobile) + scroll progress bar. Pure side-effects.
export function usePremiumFeedback() {
  useEffect(() => {
    const bar = document.createElement("div");
    bar.id = "sk-progress";
    document.body.appendChild(bar);
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      bar.style.width = max > 0 ? `${Math.min(100, (h.scrollTop / max) * 100)}%` : "0%";
    };
    const onTap = (e) => {
      if (!("vibrate" in navigator) || !e.target.closest) return;
      if (e.target.closest("a[href], button, [role=button], input[type=submit]")) navigator.vibrate(8);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("pointerdown", onTap, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("pointerdown", onTap);
      bar.remove();
    };
  }, []);
}
